var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecureOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3047 2.26953C12.7969 2.48828 13.125 2.95312 13.125 3.47266C13.125 10.582 7.90234 13.9727 6.53516 13.9727C5.16797 13.9727 0 10.5273 0 3.47266C0 2.95312 0.300781 2.48828 0.792969 2.26953L6.04297 0.0820312C6.20703 0.0273438 6.37109 0 6.5625 0C6.72656 0 6.89062 0.0273438 7.05469 0.0820312L12.3047 2.26953ZM6.5625 12.6602C9.10547 11.5938 11.8125 8.23047 11.8125 3.47266L6.5625 1.28516L1.3125 3.47266C1.3125 8.12109 3.88281 11.5664 6.5625 12.6602ZM5.03125 6.72656L5.85156 7.54688L8.01172 5.00391C8.14844 4.83984 8.33984 4.78516 8.53125 4.78516C9.02344 4.78516 9.1875 5.22266 9.1875 5.44141C9.1875 5.57812 9.13281 5.74219 9.02344 5.85156L6.39844 8.91406C6.20703 9.13281 5.96094 9.16016 5.90625 9.16016C5.71484 9.16016 5.55078 9.10547 5.44141 8.96875L4.12891 7.65625C3.99219 7.54688 3.9375 7.38281 3.9375 7.19141C3.9375 6.83594 4.21094 6.53516 4.59375 6.53516C4.75781 6.53516 4.92188 6.61719 5.03125 6.72656Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureOutlined);
export default __webpack_public_path__ + "static/media/SecureOutlined.af489065.svg";
export { ForwardRef as ReactComponent };